import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Ad from '@ifeng-fe/ui_pc_ad';
import { NormalSlides, InformationFlow } from 'ThreeTerminal_mobile_dynamic';
import styles from './index.css';
import { h5PageCount } from 'ThreeTerminal_utils';
import RelateTitle from '../relateTitle';

/**
 * 定义 recVideos 组件
 */
class RecVideos extends PureComponent {
    static propTypes = {
        content: PropTypes.array,
        bigPicSwiperData: PropTypes.array,
        ad: PropTypes.object,
        recommendVideoTwoPic1Ad: PropTypes.object,
    };

    clickSlideHandle = item => {
        h5PageCount([
            {
                behavior: 'action',
                type: 'readtoad',
                other: {
                    ref: encodeURIComponent(item.url),
                    kind: 'other',
                    tag: 't8',
                    rnum: item.id,
                },
            },
        ]);
    };

    render() {
        const { content, bigPicSwiperData, ad, recommendVideoTwoPic1Ad } = this.props;

        return content.length > 0 ? (
            <div className={styles.recVContainer}>
                <RelateTitle content="推荐视频" />
                <InformationFlow
                    content={content}
                    isEnd={true}
                    isLazyImage
                    isScrollLoadingData={false}
                    isDisplayLoadingMore={false}
                />
                {recommendVideoTwoPic1Ad && <Ad content={recommendVideoTwoPic1Ad} />}
                {ad && <Ad content={ad} />}
                {/* </div> */}
                {bigPicSwiperData.length > 0 && (
                    <div className={styles.bigPicSwiper}>
                        <NormalSlides content={bigPicSwiperData} clickSlideHandle={this.clickSlideHandle} />
                    </div>
                )}
            </div>
        ) : null;
    }
}

export default errorBoundary(RecVideos);
